import { Autocomplete, Button, CircularProgress, Dialog, DialogContent, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import icon_suscess from "../../../../../Image/icon_suscess.png";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import LoadingIndicator from '../Loading/LoadingIndicator';
import DialogCompletedApprover from './DialogCompletedApprover';
interface IDataDialogNoInformationFound {
    setOpenErrorDialog: (open: boolean) => void;
    openErrorDialog: boolean;
}

interface Film {
    title: string;
    year: number;
}

interface IDataChangeSuscess {
    setOpenDialogSuscess: any;
    openDialogSuscess: any;
    handleSaveChange:any;
    setOpenChangeApprover:any;
    loadingBTN:any;
}

const sleep = (ms: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, ms));

const top100Films = [
    { title: "The Shawshank Redemption", year: 1994 },
    { title: "The Godfather", year: 1972 },
    { title: "The Godfather: Part II", year: 1974 },
    { title: "The Dark Knight", year: 2008 },
    { title: "12 Angry Men", year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: "Pulp Fiction", year: 1994 },
];



const DialogConfirmApprover: React.FC<IDataChangeSuscess> = ({setOpenDialogSuscess,openDialogSuscess,handleSaveChange,loadingBTN,setOpenChangeApprover}) => {
    const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
    const [openAutocomplete, setOpenAutocomplete] = useState(false);
    const [options, setOptions] = useState<Film[]>([]);
    const [inputValueAutocomplete, setInputValueAutocomplete] = useState("");
    const [openModalComplete, setOpenModalComplete] = useState<boolean>(false);

    useEffect(() => {
        if (!openAutocomplete) {
            setOptions([]);
            return;
        }

        setLoadingAutocomplete(true);
        sleep(1000).then(() => {
            setLoadingAutocomplete(false);
            setOptions(top100Films);
        });
    }, [openAutocomplete]);
    const handleCloseErrorDialog = () => {
        setOpenDialogSuscess(false);
    };

    const handleOpen = useCallback(() => setOpenAutocomplete(true), []);


    const handleChangApprover = async()=>{

       await handleSaveChange();
       await setOpenModalComplete(true);
       await setOpenDialogSuscess(false);
       await setOpenChangeApprover(false);
    }

    return (
        <div>
             <LoadingIndicator open={loadingBTN} />
            <Dialog
                open={openDialogSuscess}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        handleCloseErrorDialog();
                    }
                }}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: {
                        bgcolor: "#FFFFFF",
                        borderRadius: "20px",
                        boxShadow: 3,
                        p: 1,
                        width: "500px",
                    },
                }}
            >
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                    >
                        <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>

                            <Grid item xs sx={{ position: 'absolute', right: 8 }}>
                                <IconButton
                                    aria-label="delete"
                                onClick={() =>setOpenDialogSuscess(false)}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} mt={2}>

                            <Grid item justifyContent={'center'} display={'flex'}>
                                <img
                                    src={icon_suscess}
                                    alt="รูปภาพ"
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                    }}
                                />
                            </Grid>
                            <Typography
                                sx={{
                                    color: "#2F4165",
                                    fontSize: "19px",
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    mt: 1
                                }}
                            >
                                ต้องการยืนยันการเปลี่ยนแปลงผู้มีสิทธิ์อนุมัติ
                            </Typography>

                            <Typography color={'#434343'} textAlign={'center'}>คุณต้องการยืนยันการเปลี่ยนแปลงผู้มีสิทธิ์อนุมัติเอกสาร
                                ในนามกระทรวงสาธารณสุขใช่หรือไม่</Typography>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} display={'flex'} mt={4} gap={2}>
                        <Button
                        onClick={handleCloseErrorDialog}
                            variant="outlined"
                            color="error"
                            sx={{ fontFamily: "Sarabun, sans-serif", borderRadius: 5, pl: 5, pr: 5 }}>
                            ยกเลิก
                        </Button>
                        <Button
                            onClick={handleChangApprover}
                            variant='contained'
                            sx={{ backgroundColor: '#0288D1', borderRadius: 5, pl: 5, pr: 5 }}>ยืนยัน</Button>
                    </Grid>
                </DialogContent>
            </Dialog>
            <DialogCompletedApprover 
            setOpenModalComplete={setOpenModalComplete} 
            openModalComplete={openModalComplete}
            setOpenDialogSuscess={setOpenDialogSuscess}/>
        </div>
    )
}

export default DialogConfirmApprover;
